<template>
  <div id="app">
    <div class="phone-frame">
      <div class="phone-notch"></div>
      <div class="phone-content">
        <router-view/>
        <div v-if="showFooter" class="phone-footer-wrap">
          <Footer/>
        </div>
      </div>
      <div class="phone-indicator"></div>
    </div>
  </div>
</template>

<script>
import Footer from './common/Footer'

export default {
  name: 'app',
  components: {
    Footer
  },
  computed: {
    showFooter() {
      return ['/home', '/video', '/certification', '/choose', '/mine']
        .includes((this.$route.path || '').toLowerCase());
    }
  },
  data() {
    return {
      status: 0
    };
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        this.$store.commit('setBaseInfoValue', res.data);
      }).catch(() => {
        // 捕获可能出现的异常，避免控制台红字报错
        console.error("获取基础信息失败");
      });
    },
    checkAuthAndInit() {
      const token = localStorage.getItem('token');
      const isAuthPage = ['/Login', '/Register', '/Language'].includes(this.$route.path);

      // 同步拦截：如果没有 token 且当前不在白名单页面，立刻跳转，拒绝闪烁！
      if (!token && !isAuthPage) {
        // 使用空箭头函数捕获冗余导航报错，解决 ESLint no-unused-vars 问题
        this.$router.push({ path: '/Login' }).catch(() => {});
        return; 
      }

      // 验证通过，正常请求基础信息
      this.getBaseInfo();
    }
  },
  created() {
    this.checkAuthAndInit();
  },
  watch: {
    // 监听路由变化，解决 ESLint 中 from 未使用的问题
    '$route'(to) {
      if (!localStorage.getItem('token') && !['/Login', '/Register', '/Language'].includes(to.path)) {
        this.$router.push({ path: '/Login' }).catch(() => {});
      }
    }
  }
}
</script>

<style>
/* Toast style 等全局样式统一放在 base.css 中管理 */
@import "./assets/css/base.css";

/* Phone frame base styles */
.phone-frame {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  background: transparent;
}
.phone-content {
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.phone-footer-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
</style>
